import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { PublicUser } from "@/app/types/auth/PublicUser";

export type UserState = {
  user: PublicUser | null;
  setUser: (user: PublicUser) => void;
  decrementProcessingBalance: (amount: number) => void;
};

export const UserStore = create<UserState>()(
  devtools((set, getState) => ({
    user: null,

    setUser: (user) => set({ user }),

    decrementProcessingBalance: (amount: number) => {
      const user = getState().user;
      if (!user) return;
      set({
        user: {
          ...user,
          processingBalance: Math.max(0, user.processingBalance - amount),
        },
      });
    },
  })),
);
